import SaveIcon from '@mui/icons-material/Save'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import { ClearIcon } from '@mui/x-date-pickers'
import { message } from 'antd'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { menuItemsTagsOptions } from '../../../constants/chat'
import { ERRORS_MESSAGE_MAPPER } from '../../../constants/errors'
import { axiosInstance } from '../../../hooks/useAxios'
import { IFacebookChatRoomTag } from '../../../types/facebook'
import TagsInputForm from './TagsInputForm'
import { useDispatch } from 'react-redux'
import { updateChatRoomsTags } from '../../../../store/reducers/facebook/facebook-chat.slice'

interface TagFormModalProps {
  id: string
  open: boolean
  onClose: () => void
  handleMutate: () => void
  setTags: (tags: IFacebookChatRoomTag[]) => void
}

const TagFormModal = (props: TagFormModalProps) => {
  const { open, onClose, handleMutate, id, setTags } = props
  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues: {
      tags: [],
      color: '',
    },
    validationSchema: Yup.object({
      tags: Yup.array().min(1, 'กรุณาเลือกแท็ก'),
      color: Yup.string().required('กรุณาเลือกสีแท็ก'),
    }),
    onSubmit: async (values: any) => {
      try {
        const response = await axiosInstance.post(
          `/facebook/pages/chatrooms/tags`,
          {
            id,
            names: values.tags,
            color: values.color,
          },
        )
        const { data } = response
        setTags(data.tags as IFacebookChatRoomTag[])
        handleMutate()
        onClose()
        dispatch(updateChatRoomsTags(data))
        formik.resetForm()
      } catch (e: any) {
        const messageError =
          ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] ||
          'บันทึกข้อมูลไม่สำเร็จ'
        message.error(messageError)
      }
    },
  })

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">สร้างแท็กใหม่</DialogTitle>
      <DialogContent>
        <Box component="form" mt={1} onSubmit={formik.handleSubmit}>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} lg={12}>
              <TagsInputForm
                tags={formik.values.tags}
                setTags={(tags: string[]) => formik.setFieldValue('tags', tags)}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="type-label">เลือกสีแท็ก</InputLabel>
                <Select
                  id="color"
                  name="color"
                  labelId="type-label"
                  value={formik.values.color}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                >
                  <MenuItem disabled value="" selected>
                    <em>เลือกแท็ก</em>
                  </MenuItem>
                  {menuItemsTagsOptions.map((item, index: number) => (
                    <MenuItem value={item.value} key={index}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {formik.values.color && (
              <Grid
                item
                xs={12}
                lg={12}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <Tag name={'ตัวอย่าง'} color={formik.values.color} />
              </Grid>
            )}
          </Grid>
          <Grid container spacing={2} mt={2} justifyContent={'flex-end'}>
            <Grid item>
              <Button
                startIcon={<SaveIcon />}
                color="primary"
                type="submit"
                size="large"
                variant="contained"
              >
                สร้างแท็ก
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="inherit"
                size="large"
                variant="contained"
                onClick={() => onClose()}
                startIcon={<ClearIcon />}
              >
                ปิดหน้าต่าง
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

const Tag = ({ name, color }: { name: string; color: string }) => (
  <Box
    sx={{
      px: 2,
      py: 0.5,
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: 2,
      bgcolor: color,
      color: '#fff',
      fontSize: '1.2rem',
      fontWeight: 'bold',
    }}
  >
    {name}
  </Box>
)

export default TagFormModal
